import React from "react";
import Imagecarousel from "../Components/image-carousel";
import Dokmencollection from "../Components/dokmen-collection";
import Happyfeets from "../Components/happy-feets";
import Dokmensocks from "../Components/dokmen-socks";
import Dokmenicons from "../Components/dokmen-icons";
import Reviews from "../Components/reviews";

export default function Home(props) {
  return (
    <div>
      <div style={{ height: "108px" }}></div>

      <Imagecarousel />
      <Dokmencollection />
      <hr />
      <Happyfeets />
      <Dokmensocks />
      <Dokmenicons whyDokmenRef={props.whyDokmenRef} />
      <Reviews />
    </div>
  );
}
